/**
 * A layout that has a 3-column sidebar on the left and a 9-column main
 * content on the right. The sidebar disappears on non-Desktop screens.
 *
 * This is a top-level grid layout component, which means it is not designed
 * to be used inside of another grid component.
 */
import React from 'react';
import {CssGrid, CssGridRow, CssGridColumn, CssGridSpace} from '../layouts/CssGrid';

import CoreMetrics, {createExpandableMediaQueryStylesheet, sharedFormFactorChangeListener} from '../core/Metrics';


export default class MainAndSidebarLayout extends React.Component {
    render() {
        const {sidebarContent, mainContent} = this.props;

        const styles = createExpandableMediaQueryStylesheet({
            grid: {
                paddingLeft: CoreMetrics.Grid.HorizontalMargin,
                paddingRight: CoreMetrics.Grid.HorizontalMargin,
            },
        });

        const tabletSidebarMargin = <CssGridSpace
            size={0}
            sizeTablet={2}
        />;

        return <div>
            <CssGrid styles={[styles.grid]}>
                <CssGridRow>
                    <CssGridColumn
                        size={3}
                        sizePhone={0}
                        sizeTablet={0}
                    >
                        {sidebarContent}
                    </CssGridColumn>

                    <CssGridColumn
                        sizeDesktop={9}
                        sizeTablet={12}
                    >
                        {mainContent}
                    </CssGridColumn>
                </CssGridRow>

                <CssGridRow>
                    {tabletSidebarMargin}
                    <CssGridColumn
                        sizeDesktop={0}
                        sizePhone={4}
                        sizeTablet={8}
                    >
                        {sidebarContent}
                    </CssGridColumn>
                    {tabletSidebarMargin}
                </CssGridRow>
            </CssGrid>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/layouts/MainAndSidebarLayout.jsx